import axios from "axios";
import { Auth } from "../firebase/firebase.config";

// Initialize axios instance with base URL
const API_URL = process.env.REACT_APP_BACKEND_API_URL;
const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.request.use(
  async (config) => {
    const user = Auth.currentUser;

    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// HTTP request methods (Get, Put, Post, Patch & Delete)
export const get = async (url, config = {}) => {
  try {
    const res = await axiosApi.get(url, config);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const post = async (url, data, config = {}) => {
  try {
    const res = await axiosApi.post(url, data, config);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const put = async (url, data, config = {}) => {
  try {
    const res = await axiosApi.put(url, data, config);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const del = async (url, config = {}) => {
  try {
    const res = await axiosApi.delete(url, config);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const patch = async (url, data, config = {}) => {
  try {
    const res = await axiosApi.patch(url, data, config);
    return res.data;
  } catch (error) {
    throw error;
  }
};
